import Swiper, {Navigation, Lazy, Keyboard, A11y, EffectCoverflow, Autoplay} from 'swiper';

Swiper.use([Navigation, Lazy, Keyboard, A11y, EffectCoverflow, Autoplay]);

const initSliders = () => {

    function disableScroll() {
        // Get the current page scroll position
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

            // if any scroll is attempted, set this to the previous value
            window.onscroll = function() {
                window.scrollTo(scrollLeft, scrollTop);
            };
    }
    function enableScroll() {
        window.onscroll = function() {};
    }
    if (document.querySelectorAll('.stoof-slider-wrapper').length > 0) {
        // disable lightbox scroll up bug
        if(jQuery !== undefined){
            jQuery.featherlight.prototype.afterClose = function(ev) {
                disableScroll();
                setTimeout( ()=>{enableScroll()}, 100);
                ev.preventDefault();
                ev.stopPropagation();
        }

        }
        const galleries = document.querySelectorAll('.stoof-slider-wrapper');
        galleries.forEach(gallery => {
            const auto = gallery.getAttribute('data-autoplay');
            const swiperContainer = gallery.querySelector('.swiper-container');
            const random = gallery.getAttribute('data-random');
            let slides = gallery.getAttribute('data-slides');
            const countSlides = gallery.querySelectorAll('.swiper-slide');

            let desktop = 1;
            let tablet = 1;
            if (slides !== '') {
                slides = slides*1
                desktop = slides;
                tablet = 1;
            }
            swiperContainer.setAttribute('data-desktop', desktop);
            swiperContainer.setAttribute('data-tablet', tablet);
            const prevSlide = gallery.querySelector('.swiper-button-prev');
            const nextSlide = gallery.querySelector('.swiper-button-next');
                const newSlider = new Swiper(swiperContainer, {
                    direction: 'horizontal',
                    grabCursor: 'true',
                    speed: 600,
                    loop: swiperContainer.getAttribute('data-loop'),
                    slidesPerView: 1,
                    centeredSlides: true,
                    initialSlide: 1,
                /*    autoplay: {
                        delay: swiperContainer.getAttribute('data-delay'),
                        disableOnInteraction: true,
                    },*/
                    breakpoints: {

                        1268: {
                            slidesPerView: swiperContainer.getAttribute('data-desktop'),
                            spaceBetween: 32,
                        },
                        780: {
                            slidesPerView: swiperContainer.getAttribute('data-tablet'),
                            spaceBetween: 16,
                        },


                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: false,
                    },
                    a11y: {
                        prevSlideMessage: 'Zurück',
                        nextSlideMessage: 'Weiter'
                    },

                    navigation: {
                        nextEl: nextSlide,
                        prevEl: prevSlide,
                    },

                });

            if(gallery.nextElementSibling !== null && gallery.nextElementSibling.classList.contains('stoof-gallery-preview-controls')){
                const previewControls = gallery.nextElementSibling;
                previewControls.addEventListener('click', ev=>{
                    if(!ev.target.closest('.stoof-gallery-preview-control')) return;
                    if(ev.target.closest('.stoof-gallery-preview-control__active')) return;
                    let targetSlide = ev.target.closest('.stoof-gallery-preview-control').getAttribute('data-slide-to')
                    newSlider.slideToLoop(targetSlide*1, 600);
                })
                const findActivePreview = (index) => {
                    let allElements = previewControls.querySelectorAll('.stoof-gallery-preview-control');
                    allElements.forEach(el =>{
                        el.classList.remove('stoof-gallery-preview-control__active');
                    })
                    let activeElement = previewControls.querySelector(`[data-slide-to="${index}"]`)
                    if(activeElement !== null){
                        activeElement.classList.add('stoof-gallery-preview-control__active');
                    }

                }
                newSlider.on('activeIndexChange', () =>{
                    findActivePreview(newSlider.realIndex);
                })
            }

        });
    }
}

export default initSliders;